import { render } from "./ProfileCountTables.vue?vue&type=template&id=646900c6&scoped=true"
import script from "./ProfileCountTables.vue?vue&type=script&lang=js"
export * from "./ProfileCountTables.vue?vue&type=script&lang=js"

import "./ProfileCountTables.vue?vue&type=style&index=0&id=646900c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646900c6"]])

export default __exports__